import { trackEvent } from 'segment_analytics/events'

const defaultEventProps = {
  platform: 'web',
}

const statsSummaryCRBookTap = ({
  ...props
}: {
  view_type: 'self' | 'other' | 'public'
}) => {
  const properties = {
    ...props,
    ...defaultEventProps,
  }
  return trackEvent('stats_summary_cr_book_tap', properties)
}

const statsSummaryCRListTap = ({
  ...props
}: {
  view_type: 'self' | 'other' | 'public'
}) => {
  const properties = {
    ...props,
    ...defaultEventProps,
  }
  return trackEvent('stats_summary_cr_list_tap', properties)
}

const bookauraBetaInfo = () => {
  return trackEvent('bookaura_beta_info', defaultEventProps)
}

const bookauraCopyLink = () => {
  return trackEvent('bookaura_copy_link', defaultEventProps)
}

const bookauraChangeSettings = ({
  ...props
}: {
  dimension: 'manual' | 'automatic'
}) => {
  const properties = {
    ...props,
    ...defaultEventProps,
  }
  return trackEvent('bookaura_change_settings', properties)
}

const bookauraChangeDimensions = ({ ...props }: { selection: string }) => {
  const properties = {
    ...props,
    ...defaultEventProps,
  }
  return trackEvent('bookaura_change_dimensions', properties)
}

const statsGenresAllTimeShareTap = ({
  ...props
}: {
  view_type: 'self' | 'other'
}) => {
  const properties = {
    ...props,
    ...defaultEventProps,
  }
  return trackEvent('stats_genres_all_time_share_tap', properties)
}

const statsAuthorsAllTimeShareTap = ({
  ...props
}: {
  view_type: 'self' | 'other'
}) => {
  const properties = {
    ...props,
    ...defaultEventProps,
  }
  return trackEvent('stats_authors_all_time_share_tap', properties)
}

const statsSummaryReviewTap = ({
  ...props
}: {
  reviewer: 'other' | 'self'
}) => {
  const properties = {
    ...props,
    ...defaultEventProps,
  }
  return trackEvent('stats_summary_review_tap', properties)
}

const statsSummaryDMUser = ({
  ...props
}: {
  friend_user_id: string
  starting_from: 'reading_history' | 'buddy_read'
}) => {
  const properties = {
    ...props,
    ...defaultEventProps,
  }
  return trackEvent('stats_summary_dm_user', properties)
}

export const bookaura = {
  statsSummaryCRBookTap,
  statsSummaryCRListTap,
  bookauraBetaInfo,
  bookauraCopyLink,
  bookauraChangeSettings,
  bookauraChangeDimensions,
  statsGenresAllTimeShareTap,
  statsAuthorsAllTimeShareTap,
  statsSummaryReviewTap,
  statsSummaryDMUser,
}
